module.exports = __webpack_public_path__ + "static/media/close.ios.0dc8a49d.png";